export const AUTH_TOKEN = 'token'
export const AUTH_INFO = 'info'
export const MAIN_INFO = 'main_info'
export const REGISTRATION_INFO = 'registration_info'
